import React, { FunctionComponent } from "react";

interface Props {
    opacity?: number;
    thickness?: number;
    type?:
        | "none"
        | "hidden"
        | "dotted"
        | "dashed"
        | "solid"
        | "double"
        | "groove"
        | "ridge"
        | "inset"
        | "outset"
        | "initial"
        | "inherit";
}

const HorizontalLine: FunctionComponent<Props> = ({ opacity = 1, thickness = 1, type = "solid" }) => {
    return (
        <div
            style={{
                borderTop: `#acacac ${thickness}px ${type}`,
                margin: "8px 0",
                opacity,
            }}
        />
    );
};

// HorizontalLine.defaultProps = {
//     opacity: 1,
//     thickness: 1
// };

export default HorizontalLine;
